// extracted by mini-css-extract-plugin
module.exports = {"slider":"slider__1xAbR","slider-paginal":"slider-paginal__2rA_4","list":"list__18F0x"};